import { render, staticRenderFns } from "./LocationCreateView.vue?vue&type=template&id=50976d59&"
import script from "./LocationCreateView.vue?vue&type=script&lang=js&"
export * from "./LocationCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports